const hidePhone = phone => {
    var newphone = phone
    if (phone && phone.length == 11) {
        newphone = phone.replace(phone.substring(3, 7), '****');
    }
    return newphone;
}

const hideName = name => {
    var newname = '******';
    if (name && name.length >= 1) {
        newname = name.substring(0, 1) + '***';
    }
    return newname;
}

//
const hideIDCardBirth = idcard => {
    var birth = '';
    if(idcard.length==18)
    {
        birth=idcard.substring(6, 14)
        return idcard.replace(birth,'*_^')
    }

      return idcard
   
}

// 时间戳转日期时间
const timestampToTime = timestamp => {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
        (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? '0' : '') + date.getDate() + " ";
    var h = (date.getHours() < 10 ? '0' : '') + date.getHours() + ":";
    var m = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ":";
    var s = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();

    return Y + M + D + h + m + s;
}
//对象复制
const cloneObj = obj => {
    let newObj = {};
    if (obj instanceof Array) {
        newObj = [];
    }
    for (let key in obj) {
        let val = obj[key];
        //newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。
        newObj[key] = typeof val === 'object' ? cloneObj(val) : val;
    }
    return newObj;
}

//获取系统参数
const getSysParams = code => {
    let value = null
    if (Array.isArray(JSON.parse(window.localStorage.getItem("adminParams")))) {
        JSON.parse(window.localStorage.getItem("adminParams")).forEach(function (v) {
            if (v.ParamCode == code) {
                value = v.ParamValue == '' ? v.DefaultValue : v.ParamValue
                return false
            }
        })
    }
    return value
}
//证件校验
const checkCardNo = (CardNo, CodeSign) => {
    //身份证验证
    if (CodeSign == 1) {
        CardNo = CardNo.toUpperCase()
        if (!isCardNo(CardNo)) {
            return '你输入的身份证号码数字验证错误,请重新输入'
        }
        // 检查省份
        if (!checkProvince(CardNo)) {
            return '您输入的身份证号码省份不正确,请重新输入'
        }
        // 校验生日
        if (!checkBirthday(CardNo)) {
            return '您输入的身份证号码生日不正确,请重新输入'
        }
        // 检验位的检测
        if (!checkParity(CardNo)) {
            return '您输入身份证号码校验位不正确,请重新输入'
        }
        return ''
    }
    //港澳台验证
    if (CodeSign == 2) {
        if (!isEmpty(CardNo)) {
            return '证件号码不能为空,请重新输入'
        }
        // if (!isHKTWCard(CardNo)) {
        //     return '你输入的港澳台证件号码验证错误,请重新输入'
        // }
        return ''
    }
    //外籍证件验证
    if (CodeSign == 3) {
        if (!isEmpty(CardNo)) {
            return '证件号码不能为空,请重新输入'
        }
        // if (!isPassPortCard(CardNo)) {
        //     return '你输入的外籍护照证件号码验证错误,请重新输入'
        // }
        return ''
    }
    //其它验证
    if (CodeSign == 4) {
        if (!isEmpty(CardNo)) {
            return '证件号码不能为空,请重新输入'
        }
        //其它证件暂未做限制
        return ''
    }
}

const isCardNo = idcard => {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/
    if (!reg.test(idcard)) {
        return false
    }
    return true
}

const checkProvince = idcard => {
    var vcity = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆'
    }
    var province = idcard.substr(0, 2)
    if (vcity[province] === null) {
        return false
    }
    return true
}
// 检查生日是否正确
const checkBirthday = idcard => {
    var len = idcard.length
    // 身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len === 15) {
        var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
        var arr_data = idcard.match(re_fifteen)
        var year = arr_data[2]
        var month = arr_data[3]
        var day = arr_data[4]
        var birthday = new Date('19' + year + '/' + month + '/' + day)
        return verifyBirthday('19' + year, month, day, birthday)
    }
    // 身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len === 18) {
        var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
        var arr_data2 = idcard.match(re_eighteen)
        var year2 = arr_data2[2]
        var month2 = arr_data2[3]
        var day2 = arr_data2[4]
        var birthday2 = new Date(year2 + '/' + month2 + '/' + day2)
        return verifyBirthday(year2, month2, day2, birthday2)
    }
    return false
}
// 校验日期
const verifyBirthday = (year, month, day, birthday) => {
    var now = new Date()
    var now_year = now.getFullYear()
    // 年月日是否合理
    if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
        // 判断年份的范围（0岁到120岁之间)
        var time = now_year - year
        if (time >= 0 && time <= 120) {
            return true
        }
        return false
    }
    return false
}
// 校验位的检测
const checkParity = idcard => {
    // 15位转18位
    idcard = changeFivteenToEighteen(idcard)
    var len = idcard.length
    if (len === 18) {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
        var cardTemp = 0
        var i;
        var valnum
        for (i = 0; i < 17; i++) {
            cardTemp += idcard.substr(i, 1) * arrInt[i]
        }
        valnum = arrCh[cardTemp % 11]
        if (valnum == idcard.substr(17, 1)) {
            return true
        }
        return false
    }
    return false
}
// 15位转18位身份证号
const changeFivteenToEighteen = idcard => {
    if (idcard.length === 15) {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
        var cardTemp = 0
        var i
        idcard = idcard.substr(0, 6) + '19' + idcard.substr(6, idcard.length - 6)
        for (i = 0; i < 17; i++) {
            cardTemp += idcard.substr(i, 1) * arrInt[i]
        }
        idcard += arrCh[cardTemp % 11]
        return idcard
    }
    return idcard
}
//军官证校验
const isOfficerCard = card => {
    // 军官证
    // 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
    // 样本： 军字第2001988号, 士字第P011816X号
    var reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;
    if (reg.test(card) === false) {
        return false
    } else {
        return true
    }
}
//户口本号码校验
const isAccountCard = card => {
    // 户口本
    // 规则： 15位数字, 18位数字, 17位数字 + X
    // 样本： 441421999707223115
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(card) === false) {
        return false
    } else {
        return true
    }
}

//姓名正则校验
const isName = name => {
    //var reg = /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\.·。]{0,8}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s]{0,8}[a-zA-Z]{1}$)/;
    var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$|^[a-zA-Z]{1,30}$/gi // 允许英文30个字母 或者2-20个汉字
    //var reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;//验证姓名正则
    if (reg.test(name) === false) {
        return false
    } else {
        return true
    }
}
//非空判断
const isEmpty = value => {
    var reg = /\S/
    return reg.test(value)
}


// 正则匹配 模糊查询
const searchByRegExp = (keyWord, list, itemName) => {
    if (!(list instanceof Array)) {
        return
    }
    var len = list.length
    var arr = []
    var reg = new RegExp(keyWord)
    for (var i = 0; i < len; i++) {
        // 如果字符串中不包含目标字符会返回-1
        var item = list[i]
        if (item[itemName].match(reg)) {
            arr.push(item)
        }
    }
    return arr
}

//判断字符串是否是对象
const isObject = str => {
    if (typeof str == 'string') {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }
}

const groupBy = (array, f) => {
    let groups = {}
    array.forEach(function (o) {
        var group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
    })
    return Object.keys(groups).map(function (group) {
        return groups[group]
    })
}

//字符串去除空格
const strTrim = str => {

    if (!str) {
        return '';
    }
    return str.replace(/\s*/g, "");
}


// 税号验证
const isDutyParagraph = (dutyParagraph, type) => {
    if (type === '2') {
        // 个人申请
        return checkIdCardNo(dutyParagraph)
    } else {
        // 企业申请
        var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/
        return reg.test(dutyParagraph)
    }
}
// 验证邮箱
const isEmail = (email) => {
    var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
    if (!reg.test(email)) {
        return false
    } else {
        return true
    }
}
// 验证手机号有效性
const isPhoneNumber = (mobile) => {
    var myreg = /^[1][3,4,6,5,7,8,9][0-9]{9}$/
    if (!myreg.test(mobile)) {
        return false
    } else {
        return true
    }
}
// 车牌号的正则表达式
const isCarNo = (CarNo) => {
    if (CarNo == null || CarNo == '') {
        return false
    }
    if (CarNo.length == 7) {
        // 车牌号判断的正则表达式
        var regExp = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/
        if (!regExp.test(CarNo)) {
            return false
        }
    } else {
        // 新能源车牌号校验
        var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
        if (!xreg.test(CarNo)) {
            return false
        }
    }

    return true
}



/* 省,直辖市代码表 */
const provinceAndCitys = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
}

/* 每位加权因子 */
const powers = ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2']

/* 第18位校检码 */
const parityBit = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

/* 性别 */
// const genders = {
//     male: '男',
//     female: '女'
// }

const checkAddressCode = function (addressCode) {
    var check = /^[1-9]\d{5}$/.test(addressCode)
    if (!check) return false
    if (provinceAndCitys[parseInt(addressCode.substring(0, 2))]) {
        return true
    } else {
        return false
    }
}

/* 校验日期码 */
const checkBirthDayCode = function (birDayCode) {
    var check = /^[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(birDayCode)
    if (!check) return false
    var yyyy = parseInt(birDayCode.substring(0, 4), 10)
    var mm = parseInt(birDayCode.substring(4, 6), 10)
    var dd = parseInt(birDayCode.substring(6), 10)
    var xdata = new Date(yyyy, mm - 1, dd)
    if (xdata > new Date()) {
        return false // 生日不能大于当前日期
    } else if ((xdata.getFullYear() == yyyy) && (xdata.getMonth() == mm - 1) && (xdata.getDate() == dd)) {
        return true
    } else {
        return false
    }
}

/* 计算校检码 */
const getParityBit = function (idCardNo) {
    var id17 = idCardNo.substring(0, 17)
    /* 加权 */
    var power = 0
    for (var i = 0; i < 17; i++) {
        power += parseInt(id17.charAt(i), 10) * parseInt(powers[i])
    }
    /* 取模 */
    var mod = power % 11
    return parityBit[mod]
}

/* 验证校检码 */
const checkParityBit = function (idCardNo) {
    var parityBit = idCardNo.charAt(17).toUpperCase()
    if (getParityBit(idCardNo) == parityBit) {
        return true
    } else {
        return false
    }
}



// 校验15位的身份证号码
const check15IdCardNo = function (idCardNo) {
    // 15位身份证号码的基本校验
    var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo)
    if (!check) return false
    // 校验地址码
    var addressCode = idCardNo.substring(0, 6)
    check = checkAddressCode(addressCode)
    if (!check) return false
    var birDayCode = '19' + idCardNo.substring(6, 12)
    // 校验日期码
    return checkBirthDayCode(birDayCode)
}

// 校验18位的身份证号码
const check18IdCardNo = function (idCardNo) {
    // 18位身份证号码的基本格式校验
    var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo)
    if (!check) return false
    // 校验地址码
    var addressCode = idCardNo.substring(0, 6)
    check = checkAddressCode(addressCode)
    if (!check) return false
    // 校验日期码
    var birDayCode = idCardNo.substring(6, 14)
    check = checkBirthDayCode(birDayCode)
    if (!check) return false
    // 验证校检码
    return checkParityBit(idCardNo)
}

/* 校验15位或18位的身份证号码 */
const checkIdCardNo = function (idCardNo) {
    // 15位和18位身份证号码的基本校验
    var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo)
    if (!check) return false
    // 判断长度为15位或18位
    if (idCardNo.length == 15) {
        return check15IdCardNo(idCardNo)
    } else if (idCardNo.length == 18) {
        return check18IdCardNo(idCardNo)
    } else {
        return false
    }
}

const getMainUrlHash = function (type) {
    var hash = window.location.hash.replace('#/','')
    return hash
}

//获取主要参数 type=1 返回字符串 type=2返回JSON对象
const getMainUrlParam = function (type,containhash=false) {
    var names = ['appId', 'agent','cp','st']
    var para = type == 1 ? "" : {}
    names.forEach((name) => {
        var reg = new RegExp('(^|&)' + name.toLowerCase() + '=([^&]*)(&|$)')
        var search = window.location.search.toLowerCase()
        
        var r = search.substr(1).match(reg) // search,查询？后面的参数，并匹配正则
        if (r != null) {
            if (type == 1) {
               if(para.length>0){
                 para += "&"
                }
                para += (name + "=" + unescape(r[2]))                            
            }

            if (type == 2) {
                para[name] = unescape(r[2])
            }

            if(type==1&&containhash&&window.location.hash){               
                para += ( "hashtag=" +  window.location.hash.replace("#/",""))         
                para += "&"
            }
        }
    });
    return para
}

const getParameterValues = function (name, isNotToLowerCase,isunescape=false) {
    var names = name.toLowerCase()
    if (isNotToLowerCase) {
        names = name
    }
    var reg = new RegExp('(^|&)' + names + '=([^&]*)(&|$)')
    var search = window.location.search.toLowerCase()
    if (isNotToLowerCase) {
        search = window.location.search
    }
    var r = search.substr(1).match(reg) // search,查询？后面的参数，并匹配正则
    if (r != null) return decodeURI(isunescape?unescape(r[2]):r[2])
    return null
}
/**
 * 判断是否是微信环境
 */
const getIsWxClient = function () {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    }
    return false
}


const utils = {
    hidePhone: hidePhone,
    hideName: hideName,
    hideIDCardBirth:hideIDCardBirth,
    timestampToTime: timestampToTime,
    cloneObj: cloneObj,
    getSysParams: getSysParams,
    checkCardNo: checkCardNo,
    isPhoneNumber: isPhoneNumber,
    isEmail: isEmail,
    isDutyParagraph: isDutyParagraph,
    isAccountCard: isAccountCard,
    isOfficerCard: isOfficerCard,
    isName: isName,
    isEmpty: isEmpty,
    isCarNo: isCarNo,
    searchByRegExp: searchByRegExp,
    isObject: isObject,
    groupBy: groupBy,
    strTrim: strTrim,
    checkIdCardNo: checkIdCardNo,
    getParameterValues: getParameterValues,
    getIsWxClient: getIsWxClient,
    getMainUrlParam: getMainUrlParam,
    getMainUrlHash:getMainUrlHash
};

export const isObjects = isObject;
export default utils